import { CardBrandEnum } from "../models/CardBrandEnum";
var mastercardRegex = new RegExp("^5[1-5][0-9]{5,}|^222[1-9][0-9]{3,}|^22[3-9][0-9]{4,}|^2[3-6][0-9]{5,}|^27[01][0-9]{4,}|^2720[0-9]{3,}$");
var visaRegex = new RegExp("^4[0-9]{6,}$");
var validate = function (expressionsArray) {
    if (expressionsArray === void 0) { expressionsArray = []; }
    var errorMessage = [];
    expressionsArray.forEach(function (expression) {
        var value = expression.value, error = expression.error;
        if (value)
            errorMessage.push(error);
    });
    return errorMessage;
};
export var validateSrciInitParams = function (srciLogicSdkInitParams) {
    var srciDpaId = srciLogicSdkInitParams.srciDpaId
        ? srciLogicSdkInitParams.srciDpaId.replace("_systemtest", "")
        : srciLogicSdkInitParams.srciDpaId;
    var validationExpressions = [
        { value: !srciLogicSdkInitParams.srcInitiatorId, error: "'srcInitiatorId' must be defined" },
        { value: !srciLogicSdkInitParams.pspName, error: "'pspName' must be defined" },
        { value: !srciLogicSdkInitParams.srcInitiatorId, error: "'srcInitiatorId' must be defined" },
        { value: !srciDpaId, error: "'srciDpaId' must be defined" },
        { value: !isUUID(srciDpaId), error: "'srciDpaId' must be UUID" },
        { value: !srciLogicSdkInitParams.srciTransactionId, error: "'srciTransactionId' must be defined" },
        { value: !srciLogicSdkInitParams.dpaTransactionOptions, error: "'dpaTransactionOptions' must be defined" },
        {
            value: srciLogicSdkInitParams.dpaTransactionOptions && !srciLogicSdkInitParams.dpaTransactionOptions.dpaLocale,
            error: "'dpaLocale' in 'dpaTransactionOptions' must be defined",
        },
    ];
    if (srciLogicSdkInitParams.dpaTransactionOptions && srciLogicSdkInitParams.dpaTransactionOptions.transactionAmount) {
        validationExpressions.push({
            value: srciLogicSdkInitParams.dpaTransactionOptions.transactionAmount &&
                (!srciLogicSdkInitParams.dpaTransactionOptions.transactionAmount.transactionAmount ||
                    !srciLogicSdkInitParams.dpaTransactionOptions.transactionAmount.transactionCurrencyCode),
            error: "'transactionAmount' object requires 'transactionAmount' and 'transactionCurrencyCode' fields defined",
        });
    }
    var errorMessage = validate(validationExpressions);
    if (errorMessage.length > 0)
        throw "srciLogicSdkInitParams object error: ".concat(errorMessage.join(", "));
};
var isUUID = function (uuid) {
    var regex = new RegExp("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$");
    return regex.test(uuid);
};
export var validateCardDetails = function (cardDetails) {
    var panMonthInNumber = parseInt(cardDetails.panExpirationMonth);
    var panYearInNumber = parseInt(cardDetails.panExpirationYear);
    var validationExpressions = [
        { value: !cardDetails.primaryAccountNumber, error: "'primaryAccountNumber' must be defined" },
        { value: !cardDetails.panExpirationMonth, error: "'panExpirationMonth' must be defined" },
        { value: Number.isNaN(panMonthInNumber), error: "'panExpirationMonth' must be digits" },
        { value: Number.isNaN(panYearInNumber), error: "'panExpirationYear' must be digits" },
        { value: !cardDetails.panExpirationYear, error: "'panExpirationYear' must be defined" },
        { value: !cardDetails.cardSecurityCode, error: "'cardSecurityCode' must be defined" },
        { value: !isCardSecurityCodeValid(cardDetails.cardSecurityCode), error: "'cardSecurityCode' is not valid" },
    ];
    if (cardDetails.primaryAccountNumber) {
        validationExpressions.push({
            value: !(isCardNumberValid(cardDetails.primaryAccountNumber.toString(), CardBrandEnum.MASTERCARD) ||
                isCardNumberValid(cardDetails.primaryAccountNumber.toString(), CardBrandEnum.VISA)),
            error: "'primaryAccountNumber' is not valid",
        });
    }
    if (!Number.isNaN(panMonthInNumber) && !Number.isNaN(panYearInNumber)) {
        validationExpressions.push({
            value: !isMonthRangeValid(panMonthInNumber),
            error: "'panExpirationMonth' is not valid",
        }, {
            value: !new RegExp("^(0[1-9]|1[012])$").test(cardDetails.panExpirationMonth),
            error: "'panExpirationMonth' must be in MM format",
        }, {
            value: !new RegExp("^\\d{4}$").test(cardDetails.panExpirationYear),
            error: "'panExpirationYear'  must be in YYYY format",
        }, {
            value: !isPanExpirationDateInFuture(panYearInNumber, panMonthInNumber),
            error: "card expiration date should not be from the past",
        });
    }
    var errorMessage = validate(validationExpressions);
    if (errorMessage.length > 0)
        throw "CardDetails object error: ".concat(errorMessage.join(", "));
};
function isMonthRangeValid(panMonthInNumber) {
    return panMonthInNumber > 0 && panMonthInNumber < 13;
}
export var isCardExpirationDateValid = function (panExpirationYear, panExpirationMonth) {
    var panMonthInNumber = parseInt(panExpirationMonth);
    var panYearInNumber = parseInt(panExpirationYear);
    if (!panMonthInNumber || !panYearInNumber) {
        return false;
    }
    if (!Number.isNaN(panMonthInNumber) && !Number.isNaN(panYearInNumber)) {
        if (isMonthRangeValid(panMonthInNumber)) {
            return isPanExpirationDateInFuture(panYearInNumber, panMonthInNumber);
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
};
export var isPanExpirationDateInFuture = function (panExpirationYear, panExpirationMonth) {
    var cardExpirationDateMiliseconds = new Date(panExpirationYear, panExpirationMonth);
    var nowDateMiliseconds = new Date(Date.now());
    if (cardExpirationDateMiliseconds < nowDateMiliseconds)
        return false;
    return true;
};
export var isCardSecurityCodeValid = function (cvv) {
    var cvvRegex = /^[0-9]{3,4}$/;
    if (cvvRegex.test(cvv))
        return true;
    return false;
};
export var validateEnrollCardParams = function (enrollCardParams) {
    var validationExpressions = [{ value: !enrollCardParams, error: "'enrollCardParams' must be defined" }];
    if (enrollCardParams) {
        validationExpressions.push({ value: !enrollCardParams.encryptedCard, error: "'encryptedCard' must be defined" });
        validationExpressions.push({
            value: typeof enrollCardParams.idToken !== "undefined" &&
                enrollCardParams.idToken !== null &&
                enrollCardParams.idToken.length === 0,
            error: "'idToken' requires to be not empty if defined",
        });
    }
    var errorMessage = validate(validationExpressions);
    if (errorMessage.length > 0)
        throw "EnrollCardParams object error: ".concat(errorMessage.join(", "));
};
export var isCardNumberValid = function (cardNumber, cardBrand) {
    var cardNumberWithoutSpaces = cardNumber.replace(/ /g, "");
    var isCardNumberOnlyDigits = new RegExp("^[0-9]*$").test(cardNumberWithoutSpaces);
    if (!isCardNumberOnlyDigits)
        return false;
    if (!cardBrand) {
        return luhnCheck(cardNumberWithoutSpaces);
    }
    var regex;
    var lengthValidationCheck = function (length) {
        return false;
    };
    switch (cardBrand) {
        case CardBrandEnum.MASTERCARD: {
            regex = mastercardRegex;
            lengthValidationCheck = function (length) {
                return length === 16;
            };
            break;
        }
        case CardBrandEnum.VISA: {
            regex = visaRegex;
            lengthValidationCheck = function (length) {
                return length <= 19 && length >= 13;
            };
            break;
        }
        default:
            return false;
    }
    return (regex.test(cardNumberWithoutSpaces) &&
        lengthValidationCheck(cardNumberWithoutSpaces.length) &&
        luhnCheck(cardNumberWithoutSpaces));
};
var luhnCheck = function (cardNumber) {
    if (/[^0-9-\s]+/.test(cardNumber))
        return false;
    var nCheck = 0, bEven = false;
    cardNumber = cardNumber.replace(/\D/g, "");
    for (var n = cardNumber.length - 1; n >= 0; n--) {
        var cDigit = cardNumber.charAt(n), nDigit = parseInt(cDigit, 10);
        if (bEven && (nDigit *= 2) > 9)
            nDigit -= 9;
        nCheck += nDigit;
        bEven = !bEven;
    }
    return nCheck % 10 == 0;
};
export var recognizeCardBrand = function (cardNumber) {
    var cardNumberWithoutSpaces = cardNumber.replace(/ /g, "");
    var isCardNumberOnlyDigits = new RegExp("^[0-9]*$").test(cardNumberWithoutSpaces);
    if (!isCardNumberOnlyDigits)
        return CardBrandEnum.NOT_RECOGNIZED;
    if (mastercardRegex.test(cardNumberWithoutSpaces))
        return CardBrandEnum.MASTERCARD;
    else if (visaRegex.test(cardNumberWithoutSpaces))
        return CardBrandEnum.VISA;
    else
        return CardBrandEnum.NOT_RECOGNIZED;
};
export var validateIdentityLookupParams = function (identityLookupParams) {
    var validationExpressions = [{ value: !identityLookupParams, error: "'identityLookupParams' must be defined" }];
    if (identityLookupParams) {
        validationExpressions.push({
            value: !identityLookupParams.consumerIdentity,
            error: "'consumerIdentity' must be defined",
        });
        if (identityLookupParams.consumerIdentity) {
            validationExpressions.push({
                value: !identityLookupParams.consumerIdentity.identityType && !identityLookupParams.consumerIdentity.type,
                error: "'identityType' or 'type' must be defined",
            });
            validationExpressions.push({
                value: !identityLookupParams.consumerIdentity.identityValue,
                error: "'identityValue' must be defined",
            });
        }
    }
    var errorMessage = validate(validationExpressions);
    if (errorMessage.length > 0)
        throw "IdentityLookupParams object error: ".concat(errorMessage.join(", "));
};
export var validateGetSrcProfileParams = function (getSrcProfileParams) {
    var validationExpressions = [{ value: !getSrcProfileParams, error: "'GetSrcProfileParams' must be defined" }];
    if (getSrcProfileParams) {
        validationExpressions.push({
            value: !getSrcProfileParams.idTokens,
            error: "'idTokens' must be defined",
        });
        if (getSrcProfileParams.idTokens) {
            validationExpressions.push({
                value: getSrcProfileParams.idTokens.length <= 0,
                error: "'idTokens' must not be empty",
            });
        }
    }
    var errorMessage = validate(validationExpressions);
    if (errorMessage.length > 0)
        throw "GetSrcProfileParams object error: ".concat(errorMessage.join(", "));
};
export var isEmailValid = function (email) {
    var mainFormatWithAllowedChars = /^([a-zA-Z0-9]+(?:[\.\+\_\-]+[a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[\.\-]+[a-zA-Z0-9]+)*){1,253}\.([a-zA-Z0-9]+(?:\.+[a-zA-Z0-9]+)*)$/; //allow word chars & dot, plus, dash, underscore. First and last char in a segment can only be word like.
    var detectDuplicatedSpecialChars = /([\.\+\_\-]){2}/; //detect consecutively duplicated special chars i.e.: as.+sdf
    if (mainFormatWithAllowedChars.test(email) && !detectDuplicatedSpecialChars.test(email)) {
        var matchedGroups = email.match(mainFormatWithAllowedChars);
        if ((matchedGroups === null || matchedGroups === void 0 ? void 0 : matchedGroups.length) === 4) {
            return matchedGroups[2].length < 254 && matchedGroups[3].length < 254;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
};
